import { useQuery } from "@tanstack/react-query";
import { fetchBaseTierCollections } from "@/api/collections";

// One card per budget tier (base collection image + display name) for the Collections browse page.
export function useBaseTierCollections() {
  return useQuery({
    queryKey: ["collections", "base-tiers"],
    queryFn: fetchBaseTierCollections,
  });
}
